import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';

import style from '../export-records-modal.module.less';
import { messages } from '../messages/general-export-messages';

export const CreateOrEditFormatFooter = ({ onSave, onGoBack }) => {
  return (
    <ModalFooter className={style['export-records-modal-footer']}>
      <div className={style['right-buttons']}>
        <Button onClick={onGoBack} theme='tertiary'>
          <FormattedMessage {...messages.back} />
        </Button>
        <Button onClick={onSave} theme='primary'>
          <FormattedMessage {...messages.save} />
        </Button>
      </div>
    </ModalFooter>
  );
};

CreateOrEditFormatFooter.propTypes = {
  onSave: PropTypes.func.isRequired,
  onGoBack: PropTypes.func.isRequired,
};
